import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import {
  type SearchMultipleSelectionWithSelectAllOptionProps,
  SearchMultipleSelectionWithSelectAllOption,
} from '../search-multiple-selection-with-select-all-option';

type FormSearchMultipleSelectionWithSelectAllOptionProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> & SearchMultipleSelectionWithSelectAllOptionProps;

function FormSearchMultipleSelectionWithSelectAllOption<
  TFieldValues extends FieldValues = FieldValues,
>(props: FormSearchMultipleSelectionWithSelectAllOptionProps<TFieldValues>) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <SearchMultipleSelectionWithSelectAllOption
      {...field}
      {...props}
      error={!!error}
      required={props?.required ?? !!props.rules?.required}
      helperText={error?.message ?? props.helperText ?? null}
      onChange={props.onChange ?? ((event, item) => field.onChange(item ?? null))}
      onBlur={field.onBlur}
      inputRef={ref}
    />
  );
}

export type { FormSearchMultipleSelectionWithSelectAllOptionProps };
export { FormSearchMultipleSelectionWithSelectAllOption };
